package org.vreo.devicehub.features.userAuthentication.data.dto

import kotlinx.serialization.Serializable

/**
 * New verification code request
 *
 * @property email email address for which new verification code is requested
 */
@Serializable
data class NewVerificationCodeRequest(
    val email: String
)